import { encode } from 'js-base64'

export const recursiveFetch = async req => {
  const nodes = [];
  
  const rec = async url => {
    const response = await fetch(url);
    const fetchedData = await response.json();
  
    if (fetchedData?.data?.length > 0) {
      nodes.push(...fetchedData.data)
    }
  
    // if the next link exists, recursively fetch next set of data
    if (fetchedData?.links?.next?.href) {
      await rec(fetchedData.links.next.href);
    }
  }

  // initiate recursive function
  await rec(req);

  return nodes;
}

export const auth = () => {
  const user = process.env.REACT_APP_AUTH_USER
  const pass = process.env.REACT_APP_AUTH_PASS
  const options = {}

  console.log(user);
  console.log(pass);

  if (user && pass && user.length > 0 && pass.length > 0) {
    const authstring = encode(
      `${process.env.REACT_APP_AUTH_USER}:${process.env.REACT_APP_AUTH_PASS}`
    )

    options.credentials = 'include'
    options.headers = {
      Authorization: `Basic ${authstring}`
    }
  }

  console.log('TEMP DEBUG: ', options);

  return options
}

export const fetchAuthed = async (endpoint)=> {
  const options = auth()
  const fetched = await fetch(endpoint, options).then(res => res.json()).catch(err => console.log({ err }))

  return fetched
}
